import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function ICSEresult() { 
  useEffect(() => {
    document.title = ' ICSE Result -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li> ISCE  </li>
                <li>  ICSE Result</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">ICSE Result</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <div className="table-responsive">
               <table className="table maintable">
                <thead>
                   <tr>
                     <th width="20px">SL.NO</th>
                      <th width="500px"> Icse Result </th>
                      <th width="20px"> Year</th>
                      <th width="20px" text-align='center'>Download</th>
                    </tr>
                 </thead>
                   <tbody>
                      <tr>
                        <td>1</td>
                        <td>ICSE Result </td>
                        <td>2018-2019</td>
                        <td><Link to="https://webapi.entab.info/api/image/MMSKN/public/pdf/ICSE-2019.pdf" target="blank"><i className="bi bi-file-earmark-arrow-down"></i></Link></td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>ICSE Result </td>
                         <td>2017-2018</td>
                        <td><Link to="https://webapi.entab.info/api/image/MMSKN/public/pdf/icse_best_five_2018.pdf" target="blank"><i className="bi bi-file-earmark-arrow-down"></i></Link></td>
                      </tr>
                     </tbody>
                  </table>
            </div>
               </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ICSEresult;
